var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#002240",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.18753 8C6.18753 8.46413 6.3719 8.90925 6.70009 9.23744C7.02828 9.56563 7.4734 9.75 7.93753 9.75C8.40166 9.75 8.84678 9.56563 9.17497 9.23744C9.50315 8.90925 9.68753 8.46413 9.68753 8C9.68753 7.53587 9.50315 7.09075 9.17497 6.76256C8.84678 6.43437 8.40166 6.25 7.93753 6.25C7.4734 6.25 7.02828 6.43437 6.70009 6.76256C6.3719 7.09075 6.18753 7.53587 6.18753 8ZM14.7219 7.59688C13.2407 4.47656 11.0016 2.90625 8.00003 2.90625C4.9969 2.90625 2.7594 4.47656 1.27815 7.59844C1.21874 7.72425 1.18793 7.86165 1.18793 8.00078C1.18793 8.13991 1.21874 8.27732 1.27815 8.40312C2.7594 11.5234 4.99847 13.0938 8.00003 13.0938C11.0032 13.0938 13.2407 11.5234 14.7219 8.40156C14.8422 8.14844 14.8422 7.85469 14.7219 7.59688ZM7.93753 10.75C6.41878 10.75 5.18753 9.51875 5.18753 8C5.18753 6.48125 6.41878 5.25 7.93753 5.25C9.45628 5.25 10.6875 6.48125 10.6875 8C10.6875 9.51875 9.45628 10.75 7.93753 10.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.d0be172dc119edc7799c4a60f05e1c2f.svg";
export { ForwardRef as ReactComponent };